module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.showModal) ? _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__bg"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('Icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _c('div', {
    staticClass: "modal__form"
  }, [_c('Form')], 1)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-659d1917","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/modal.pug
// module id = 592
// module chunks = 1